<script>

import NotifyHistory from '@/components/dingTalkNotify/NotifyHistory.vue'
import employeesDialog from '@/components/workflow/dialog/employeesDialog.vue'
import { updateArtistDivideAgent } from '@/api/artist_divide'

export default {
  name: 'ArtistCommissionComponentsNotifySend',
  components: { employeesDialog, NotifyHistory },
  data() {
    return {
      dialogVisible: false,
      notifyTypeMap: {
        assistant: { txt: '确认通知', value: 'assistant', disabled: false },
        // { txt: '财审通知', value: 'finance' },
        payment: { txt: '打款通知', value: 'payment', disabled: true }
      },
      msgStataMap: {
        1: { text: '未通知', value: 1, type: '' },
        2: { text: '分成通知', value: 2, type: 'warning' },
        3: { text: '分成已读', value: 3, type: 'success' },
        4: { text: '打款通知', value: 4, type: 'warning' },
        5: { text: '打款已读', value: 5, type: 'success' }
      },
      statusAuditSet: {
        1: { text: '待确认', value: 1 },
        3: { text: '分成确认', value: 3 },
        7: { text: '打款确认', value: 7 }
      },
      isShowNotifyHistory: false,
      formData: {
        nickname: null,
        agent_name: null,
        agent_userid: null,
        msg_status: null,
        audit: null,
        notify_type: 'assistant'//1-确认通知
      },
      visible: false,
      checkedList: []
    }
  },
  methods: {
    open(row) {
      if (row.audit === 1) {
        row.notify_type = 'assistant'
      }
      // 分成已确认
      if (row.audit === 3) {
        row.notify_type = 'payment'
        this.notifyTypeMap['payment'].disabled = false
      }

      this.formData = {
        id: row.id,
        nickname: row.nickname,
        msg_status: row.msg_status,
        audit: row.audit,
        notify_type: row.notify_type,
        agent_userid: row.agent_userid,
        agent_name: row.agent_name
      }
      this.dialogVisible = true
    },
    sendNotify() {
      const notifyTypeObj = this.notifyTypeMap[this.formData.notify_type]
      if (!this.formData.id) {
        return false
      }
      if (!this.formData.agent_userid) {
        this.msgWarn('通知对象必选')
        return false
      }
      if (!this.formData.notify_type) {
        this.msgWarn('通知类型必选')
        return false
      }
      this.$confirm(`确认给『${this.formData.agent_name}』发送【${notifyTypeObj.txt}】`, '消息通知', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // this.sendNotify([row])
        const data = await this.$api.dingTalkNotifyartistDivide({
          id: this.formData.id,
          rec_user_ids: [this.formData.agent_userid],
          type: this.formData.notify_type
        })
        if (data == 'ok') {
          this.$notify.success('通知已发出，可在《通知历史记录》中查询发送结果')
          this.showHistory()
        }
      })
    },
    handleChangeMembers(data) {
      this.checkedList = data
      // this.formData.userids = data.map((_member) => {
      //   if (_member.type === 1)
      //     return _member.targetId
      // })
      // this.formData.names = data.map((_member) => {
      //   if (_member.type === 1)
      //     return _member.name
      // })
      // this.visible = false
      if (data[0] && data[0].type === 1) {
        // this.nodeUserList = data
        this.formData.agent_userid = data[0]['targetId']
        this.formData.agent_name = data[0]['name']
        this.visible = false
        this.handleChangeAgent(this.formData)
        // 更新经纪人
        // this.$emit('updateAgent', this.formData)
      } else {
        this.$notify.warning('请选择一个成员')
      }

    },
    showHistory() {
      this.isShowNotifyHistory = !this.isShowNotifyHistory
      this.$nextTick(() => {
        if (this.isShowNotifyHistory && this.$refs['refNotify']) {
          this.$refs['refNotify'].getNotifyTaskList()
        }

      })

    },
    handleChangeAgent(data) {
      if (data.id && data.agent_name && data.agent_userid)
        updateArtistDivideAgent(data)
    }
  }
}
</script>

<template>
  <div>
    <!--        通知经纪人-->
    <el-dialog
      title='消息通知'
      :visible.sync='dialogVisible'
      append-to-body
      width='650px'
    >
      <div>
        <div class='theme-border' style='padding: 10px 20px'>
          <div>
            <el-tag size='large' effect='plain' :type='formData.msg_status>=2?"success":"warning"'>
              通知状态： {{ msgStataMap[formData.msg_status] ? msgStataMap[formData.msg_status].text : '--' }}
            </el-tag>
            &nbsp;
            <el-tag size='large' effect='plain' :type='formData.audit>=3?"success":"warning"'>
              确认状态：{{ statusAuditSet[formData.audit] ? statusAuditSet[formData.audit].text : '--' }}
            </el-tag>
          </div>
          <el-form v-model='formData' label-suffix='：'>
            <el-form-item label='红人昵称' required>
              <span>{{ formData.nickname || '' }}</span>
            </el-form-item>
            <el-form-item label='通知类型' required>
              <el-radio-group v-model='formData.notify_type'>
                <el-radio :label='option.value' v-for='(option) in notifyTypeMap' :key='`notify_type_${option.value}`'
                          :disabled='option.disabled'>
                  {{ option.txt }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='接收人' required>
              <template slot='label'>
                接&nbsp;&nbsp;收&nbsp;&nbsp;人：
              </template>
              <span>{{ formData.agent_name || '--' }}</span>
              <el-link style='margin-left: 10px' icon='el-icon-edit' @click='visible=true'></el-link>
            </el-form-item>
            <el-form-item>
              <el-button round size='medium' type='primary' icon='el-icon-s-promotion'
                         @click='sendNotify'>
                发送通知
              </el-button>
              <el-link style='float: right' size='medium' icon='el-icon-document'
                       @click='showHistory'>
                通知记录
                <span :class='[isShowNotifyHistory?"el-icon-arrow-up":"el-icon-arrow-down"]'></span>
              </el-link>
            </el-form-item>
          </el-form>
          <br />
          <div v-show='isShowNotifyHistory'>
            <NotifyHistory ref='refNotify' :info-id='this.formData.id' v-if='this.formData.id'></NotifyHistory>
          </div>
          <br />
        </div>
        <employees-dialog
          :isDepartment='true'
          :visible.sync='visible'
          :data.sync='checkedList'
          @change='handleChangeMembers'
        />
      </div>

      <!--          <div slot='footer' class='dialog-footer'>-->
      <!--            <el-button @click='dialogVisible = false'>取 消</el-button>-->
      <!--            <el-button type='primary' @click='dialogVisible = false'>确 定</el-button>-->
      <!--          </div>-->
    </el-dialog>
  </div>
</template>

<style scoped>

</style>
